import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { HStack } from '@looko-design-system';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Button, Menu, MenuItem, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';

import useGetShopInfo from '@/app/shop/shop-info/useGetShopInfo';
import myInfoMenus from '@/router/myInfo/MyInfoMenus';

import { useLogoutUserAuth } from '../../../../state/cookieContext';
import { shopAuthContextState } from '../../../../state/userAuthContext';

/**
 * 헤더 - 프로필 섹션
 */
export default function ProfileSection() {
  // router
  const navigate = useNavigate();

  // recoil
  const [shopAuthContext, setShopAuthContext] = useRecoilState(shopAuthContextState);

  const logoutUserAuth = useLogoutUserAuth();

  // axios
  const { data: shopInfo } = useGetShopInfo(shopAuthContext.shopID);

  // local
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const filteredMenus = myInfoMenus.filter(menu => menu.display);

  // handler
  const handleIconClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickMenu = (path: string) => {
    navigate(path);
  };

  const handleLogout = () => {
    logoutUserAuth();
    setShopAuthContext({
      shopID: '',
    });

    navigate('/login');
  };

  return (
    <>
      <Button
        onClick={handleIconClick}
        sx={{ color: 'black', p: 0 }}
        style={{ textTransform: 'none' }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <HStack alignItems={'center'} spacing={0.5}>
          <img src={'/assets/images/profile/profile.svg'} />
          <Typography variant="Body_Looko">{shopInfo?.shopName}</Typography>
          <KeyboardArrowDownIcon sx={{ color: 'black' }} />
        </HStack>
      </Button>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      >
        {filteredMenus.map(menu => (
          <MenuItem key={menu.title} onClick={() => handleClickMenu(menu.path)}>
            <Typography variant="Body_Looko" width={200}>
              {menu.title}
            </Typography>
          </MenuItem>
        ))}
        <MenuItem onClick={handleLogout}>
          <Typography variant="Body_Looko" width={200}>
            로그아웃
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
}
